export default {
  full_name: 'input',
  tagline: 'input',
  phone_number: 'input',
  email: 'input',
  address: 'input',
  objective: 'organization_role_editable_div',
  summary: 'organization_role_editable_div',
  work_experience_organization: 'organization',
  work_experience_organization_details: 'organization_details',
  work_experience_logo: 'organization_logo',
  work_experience_image: 'organization_image',
  work_experience_organization_name: 'organization_name',
  work_experience_organization_address: 'organization_address',
  work_experience_role_details: 'organization_role_details',
  work_experience_job_title: 'organization_role_title',
  work_experience_from: 'organization_role_date',
  work_experience_to: 'organization_role_date',
  work_experience_role_description: 'organization_role_editable_div',
  work_experience_role_achievements: 'organization_role_editable_div',

  education_organization: 'organization',
  education_organization_details: 'organization_details',
  education_logo: 'organization_logo',
  education_image: 'organization_image',
  education_organization_name: 'organization_name',
  education_organization_address: 'organization_address',
  education_role_details: 'organization_role_details',
  education_degree_title: 'organization_role_title',
  education_cgpa: 'organization_role_score',
  education_cgpa_min: 'organization_role_score_min',
  education_cgpa_max: 'organization_role_score_max',
  education_field_title: 'organization_role_title',
  education_from: 'organization_role_date',
  education_to: 'organization_role_date',
  education_role_description: 'organization_role_editable_div',

  awards_and_honors_organization: 'organization',
  awards_and_honors_organization_details: 'organization_details',
  awards_and_honors_logo: 'organization_logo',
  awards_and_honors_image: 'organization_image',
  awards_and_honors_organization_name: 'organization_name',
  awards_and_honors_organization_address: 'organization_address',
  awards_and_honors_role_details: 'organization_role_details',
  awards_and_honors_award_title: 'organization_role_title',
  awards_and_honors_issue_date: 'organization_role_date',
  awards_and_honors_award_description: 'organization_role_editable_div',

  volunteer_work_organization: 'organization',
  volunteer_work_organization_details: 'organization_details',
  volunteer_work_logo: 'organization_logo',
  volunteer_work_image: 'organization_image',
  volunteer_work_organization_name: 'organization_name',
  volunteer_work_organization_address: 'organization_address',
  volunteer_work_role_details: 'organization_role_details',
  volunteer_work_role_title: 'organization_role_title',
  volunteer_work_cause_title: 'organization_role_title',
  volunteer_work_from: 'organization_role_date',
  volunteer_work_to: 'organization_role_date',
  volunteer_work_role_description: 'organization_role_editable_div',

  certifications_organization: 'organization',
  certifications_organization_details: 'organization_details',
  certifications_logo: 'organization_logo',
  certifications_image: 'organization_image',
  certifications_organization_name: 'organization_name',
  certifications_organization_address: 'organization_address',
  certifications_role_details: 'organization_role_details',
  certifications_certification_title: 'organization_role_title',
  certifications_from: 'organization_role_date',
  certifications_to: 'organization_role_date',
  certifications_certification_description: 'organization_role_editable_div',

  projects_organization: 'organization',
  projects_organization_details: 'organization_details',
  projects_logo: 'organization_logo',
  projects_image: 'organization_image',
  projects_organization_name: 'organization_name',
  projects_organization_address: 'organization_address',
  projects_role_details: 'organization_role_details',
  projects_project_title: 'organization_role_title',
  projects_url_title: 'organization_role_title',
  projects_from: 'organization_role_date',
  projects_to: 'organization_role_date',
  projects_project_description: 'organization_role_editable_div',

  research_experience_organization: 'organization',
  research_experience_organization_details: 'organization_details',
  research_experience_logo: 'organization_logo',
  research_experience_image: 'organization_image',
  research_experience_organization_name: 'organization_name',
  research_experience_organization_address: 'organization_address',
  research_experience_role_details: 'organization_role_details',
  research_experience_research_title: 'organization_role_title',
  research_experience_url_title: 'organization_role_title',
  research_experience_from: 'organization_role_date',
  research_experience_to: 'organization_role_date',
  research_experience_research_description: 'organization_role_editable_div',

  leadership_organization: 'organization',
  leadership_organization_details: 'organization_details',
  leadership_logo: 'organization_logo',
  leadership_image: 'organization_image',
  leadership_organization_name: 'organization_name',
  leadership_organization_address: 'organization_address',
  leadership_role_details: 'organization_role_details',
  leadership_role_title: 'organization_role_title',
  leadership_url_title: 'organization_role_title',
  leadership_from: 'organization_role_date',
  leadership_to: 'organization_role_date',
  leadership_role_description: 'organization_role_editable_div',

  associations_organization: 'organization',
  associations_organization_details: 'organization_details',
  associations_logo: 'organization_logo',
  associations_image: 'organization_image',
  associations_organization_name: 'organization_name',
  associations_organization_address: 'organization_address',
  associations_role_details: 'organization_role_details',
  associations_association_title: 'organization_role_title',
  associations_url_title: 'organization_role_title',
  associations_from: 'organization_role_date',
  associations_to: 'organization_role_date',
  associations_association_description: 'organization_role_editable_div',

  extra_curricular_organization: 'organization',
  extra_curricular_organization_details: 'organization_details',
  extra_curricular_logo: 'organization_logo',
  extra_curricular_image: 'organization_image',
  extra_curricular_organization_name: 'organization_name',
  extra_curricular_organization_address: 'organization_address',
  extra_curricular_role_details: 'organization_role_details',
  extra_curricular_activity_title: 'organization_role_title',
  extra_curricular_url_title: 'organization_role_title',
  extra_curricular_from: 'organization_role_date',
  extra_curricular_to: 'organization_role_date',
  extra_curricular_activity_description: 'organization_role_editable_div',

  courses_organization: 'organization',
  courses_organization_details: 'organization_details',
  courses_logo: 'organization_logo',
  courses_image: 'organization_image',
  courses_organization_name: 'organization_name',
  courses_organization_address: 'organization_address',
  courses_role_details: 'organization_role_details',
  courses_course_title: 'organization_role_title',
  courses_completion_date: 'organization_role_date',
  courses_course_description: 'organization_role_editable_div',

  conferences_organization: 'organization',
  conferences_organization_details: 'organization_details',
  conferences_logo: 'organization_logo',
  conferences_image: 'organization_image',
  conferences_organization_name: 'organization_name',
  conferences_organization_address: 'organization_address',
  conferences_role_details: 'organization_role_details',
  conferences_conference_title: 'organization_role_title',
  conferences_date: 'organization_role_date',
  conferences_conference_description: 'organization_role_editable_div',

  references_organization: 'organization',
  references_organization_details: 'organization_details',
  references_logo: 'organization_logo',
  references_image: 'organization_image',
  references_organization_name: 'organization_name',
  references_organization_address: 'organization_address',
  references_reference_name_title: 'organization_role_title',
  references_reference_title: 'organization_role_title',
  references_reference_email_title: 'organization_role_title',
  references_role_details: 'organization_role_details',

  skill_organization: 'organization',
  skill_organization_details: 'organization_details',
  skill_organization_name: 'organization_name',
  skill_title: 'array_item',

  patents_organization: 'organization',
  patents_organization_details: 'organization_details',
  patents_logo: 'organization_logo',
  patents_image: 'organization_image',
  patents_organization_name: 'organization_name',
  patents_organization_address: 'organization_address',
  patents_patent_title: 'organization_role_title',
  patents_patent_id_title: 'organization_role_title',
  patents_patent_status_title: 'organization_role_title',
  patents_patent_country_title: 'organization_role_title',
  patents_patent_url_title: 'organization_role_title',
  patents_patent_description: 'organization_role_editable_div',
  patents_role_details: 'organization_role_details',
  patents_patent_date: 'organization_role_date',

  test_scores_organization: 'organization',
  test_scores_organization_details: 'organization_details',
  test_scores_logo: 'organization_logo',
  test_scores_image: 'organization_image',
  test_scores_organization_name: 'organization_name',
  test_scores_organization_address: 'organization_address',
  test_scores_test_title: 'organization_role_title',
  test_scores_cgpa: 'organization_role_score',
  test_scores_cgpa_min: 'organization_role_score_min',
  test_scores_cgpa_max: 'organization_role_score_max',
  test_scores_test_description: 'organization_role_editable_div',
  test_scores_date: 'organization_role_date',
  test_scores_role_details: 'organization_role_details',

  language: 'array_item',

  hobbies_and_interests: 'array_item',

  skill: 'array_item',
  personal_link: 'array_item',
  publication: 'array_item',

  list_item: 'list_item',
  unordered_list: 'unordered_list',

  empty_paragraph: 'empty_paragraph',
  paragraph: 'paragraph',

  // COVER LETTER
  sender_name: 'input',
  sender_phone_number: 'input',
  sender_tagline: 'input',
  sender_address: 'input',
  sender_email: 'input',
  receiver_name: 'input',
  receiver_tagline: 'input',
  receiver_organization: 'input',
  receiver_address: 'input',
  letter_date: 'cover_letter_date',
  letter_body: 'organization_role_editable_div',
  open_greeting: 'input',
  subject_line: 'input',
  close_greeting: 'input',
};
